import {
  CheckForApplicationUpdate,
  LoadingIndicator,
  Logout,
  MenuItemLink,
  UserMenu,
  useGetIdentity,
} from "react-admin";
import { ContainerLayout, Header } from "@react-admin/ra-navigation";
import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

import LocaleSwitcher from "./LocaleSwitcher";
import { Lock as LockIcon } from "@mui/icons-material";
import gql from "graphql-tag";
import { sortBy } from "lodash";
import { useMutation } from "@apollo/client";
import { useProfile } from "./hooks/useProfile";

const SET_COMPANY_MUTATION = gql`
  mutation SetCompany($companyId: String!) {
    setCompany(companyId: $companyId)
  }
`;

const CustomUserMenu = (props: any) => {
  const { identity } = useGetIdentity();

  return (
    <UserMenu {...props}>
      {!identity?.isAd && (
        <MenuItemLink
          to="/change-my-password"
          primaryText="Change my password"
          leftIcon={<LockIcon />}
          onClick={props.onClick}
          sidebarIsOpen
        />
      )}
      <Logout key="logout" />
    </UserMenu>
  );
};

export const CompaniesMenu = () => {
  const { identity }: any = useGetIdentity();
  const { fetchMe } = useProfile();
  const [setCompany] = useMutation(SET_COMPANY_MUTATION);
  const [companies, setCompanies] = useState([]);

  const [selectedCompanyId, setCompanyId] = useState(identity?.selectedCompany?.id);

  useEffect(() => {
    setCompanyId(identity?.selectedCompany?.id);
  }, [identity?.selectedCompany?.id]);

  useEffect(() => {
    async function init() {
      const response = await fetchMe();
      setCompanies(response?.getMe?.companies || []);
    }

    init();
  }, []);

  const handleOnChange = async (event) => {
    await setCompany({
      variables: {
        companyId: event.target.value
      },
    });

    await fetchMe();

    window.location.reload();
  };

  return (
    <span className="company-select">
      <Select
        value={selectedCompanyId || ''}
        placeholder=""
        size="small"
        label=""
        onChange={handleOnChange}
      >
        {sortBy(companies, ['company.name'])?.map((item) => (
          <MenuItem key={item.company.id} value={item.company.id}>
            {item.company.name} ({item.company.ingresId || item.company.carloPartnerId} - {item.company.ingresId ? 'Ingres' : 'CarLo'})
          </MenuItem>
        ))}
      </Select>
    </span>
  );
};

const CustomToolbar = (
  <>
    <LocaleSwitcher />
    <CompaniesMenu />
    <LoadingIndicator />
  </>
);

const CustomLayout = (props) => {
  return (
    <ContainerLayout
      {...props}
      appBar={
        <Header
          color="default"
          userMenu={<CustomUserMenu />}
          toolbar={CustomToolbar}
          position="sticky"
        />
      }
      maxWidth="100vw"
    />
  );
};

export default CustomLayout;
